module.exports = __webpack_public_path__ + "static/media/FoodIconsIdeas.5b7bdf05.jpg";